import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { AnaliseCritica } from "features/projetos/models/AnaliseCritica";

async function updateAnaliseCritica(analiseCritica: AnaliseCritica): Promise<IResponse<ValidationResult>> {
  return await axios.put('/AnaliseCritica/Editar', analiseCritica);
}

export default updateAnaliseCritica;